import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { PrimaryButton, DefaultButton } from '@fluentui/react/lib/Button';

const baseStyles = {
  borderRadius: 100,
  height: 42,
  minWidth: 115,
  fontSize: 20,
  lineHeight: '24px',
  border: '1px solid black',

  '&[disabled]': {
    backgroundColor: 'lightgray',
    border: '1px solid lightgray',
    color: 'darkgray',
  },
};

const getPrimaryButtonStyles = () => ({
  root: {
    ...baseStyles,
    backgroundColor: 'black',

    '&:hover': {
      backgroundColor: 'black',
      border: '1px solid black',
    },
  },
});

// Primary button for runtime page
export const SmartPrimaryButton = ({
  className,
  ...restProps
}) => {
  const classes = useDefaultStyles(getPrimaryButtonStyles);
  return (
    <PrimaryButton
      className={classNames('primitive-primary-button', classes.root, className)}
      {...restProps}
    />
  );
};

SmartPrimaryButton.defaultProps = {
  className: '',
};

SmartPrimaryButton.propTypes = {
  className: string,
};

const getDefaultButtonStyles = () => ({
  root: {
    ...baseStyles,
    backgroundColor: 'white',

    '&:hover': {
      backgroundColor: 'white',
      border: '1px solid black',
    },
  },
});

// Default button for runtime page
export const SmartDefaultButton = ({
  className,
  ...restProps
}) => {
  const classes = useDefaultStyles(getDefaultButtonStyles);
  return (
    <DefaultButton
      className={classNames('primitive-primary-button', classes.root, className)}
      {...restProps}
    />
  );
};

SmartDefaultButton.defaultProps = {
  className: '',
};

SmartDefaultButton.propTypes = {
  className: string,
};
